var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.8088 21.021C30.3573 21.021 29.7592 21.011 29.0146 21.011C27.1987 21.011 25.7055 19.508 25.7055 17.675V14.459C25.7055 14.206 25.5036 14 25.253 14H19.9636C17.4952 14 15.5 16.026 15.5 18.509V29.284C15.5 31.889 17.5902 34 20.1696 34H28.0463C30.5058 34 32.5 31.987 32.5 29.502V21.471C32.5 21.217 32.299 21.012 32.0475 21.013C31.6247 21.016 31.1177 21.021 30.8088 21.021Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.0827 14.5674C27.7837 14.2564 27.2617 14.4704 27.2617 14.9014V17.5384C27.2617 18.6444 28.1727 19.5544 29.2787 19.5544C29.9757 19.5624 30.9437 19.5644 31.7657 19.5624C32.1867 19.5614 32.4007 19.0584 32.1087 18.7544C31.0537 17.6574 29.1647 15.6914 28.0827 14.5674Z",
    fill: "#130F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9745 23.3874H24.3595C24.7705 23.3874 25.1045 23.0544 25.1045 22.6434C25.1045 22.2324 24.7705 21.8984 24.3595 21.8984H20.9745C20.5635 21.8984 20.2305 22.2324 20.2305 22.6434C20.2305 23.0544 20.5635 23.3874 20.9745 23.3874ZM20.9746 28.3816H26.4186C26.8296 28.3816 27.1636 28.0486 27.1636 27.6376C27.1636 27.2266 26.8296 26.8926 26.4186 26.8926H20.9746C20.5636 26.8926 20.2306 27.2266 20.2306 27.6376C20.2306 28.0486 20.5636 28.3816 20.9746 28.3816Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBook);
export default __webpack_public_path__ + "static/media/total_book.64880de581de128ac8b1203809b290c2.svg";
export { ForwardRef as ReactComponent };